import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { ComponentDto, VariableDto } from '../component-model/dto';
import { AttributeType } from '../component-model/model';
import { commandPermissions } from './command-permissions';
import { ConfigureResponse } from './configure';

export interface SetConfigurationValues {
  attributeType?: AttributeType;
  component: ComponentDto;
  variable: VariableDto;
  attributeValue: string;
}

export interface SetConfigurationCommand {
  configurationValues: SetConfigurationValues[];
}

export enum ChangeConfigurationStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  REBOOT_REQUIRED = 'REBOOT_REQUIRED'
}

const client = createClient('/rest/operator-api/charging-stations');

export const setConfiguration: SaveOperation<SetConfigurationCommand, ConfigureResponse, string> = postRequestFactory<
  SetConfigurationCommand,
  ConfigureResponse,
  string
>(client, {
  pattern: '/{chargingStationId}/set-configuration',
  permissionId: commandPermissions.SET_CONFIGURATION
});
